<template>
    <div class='recharge-record'>
        <div class="search-wrapper">
            <!-- <el-button class="member_button" @click="openMemberConfig">会员卡设置</el-button> -->
            <el-button type="primary" @click="isAddMemberVisible = true">+添加会员</el-button>
            <more-operate ref="moreoperate">
                <div class="operate-detail-item">
                    <div @click="openMemberConfig">会员卡设置</div>
                    <div class="more-operate-item align-l" @click="$router.push('/main/member/memberImport')">批量导入会员</div>
                </div>
            </more-operate>
            <my-search :styleData="{
                placeholder: '输入会员昵称/手机号码',
                width: '248px',
                height: '36px'
            }"  @searchData="searchData"/>
        </div>
        <el-table v-loading="isLoading"
            v-textHighlight="{
                keyword: oKeyword,
                indexs: [2, 3, 4],
                isBegin: !isLoading
            }"
            ref="elTable"
            :data="rechargeRecord"
            :height="'calc(100vh - 150px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column type="index" label="#" />
            <el-table-column label="时间" min-width="110" sortable>
                <template v-slot="{ row }">
                    <p>{{ getTime(row.create_time).y_m_d }}</p>
                    <p>{{ getTime(row.create_time).h_m_s }}</p>
                </template>
            </el-table-column>
            <el-table-column label="订单编号" min-width="180">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.order_no }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="balance" label="会员" min-width="160">
                <template v-slot="{ row }">
                    <user-info 
                        :userInfo="{
                            avatar: get(row, 'member.user.avatar') || '../../../assets/images/default_avatar.svg',
                            nickname: get(row, 'member.user.nickname'),
                            realname: get(row, 'member.name'),
                            gender: get(row, 'member.user.gender')
                        }"
                        :canClick="true"
                        :url="'/main/member/memberDetail/balanceChange?id=' + get(row, 'member.id')"/>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_recharge" label="会员手机号" min-width="110">
                <template v-slot="{ row }">
                    <span>{{ get(row, 'member.phone') }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_consume" label="充值金额(元)" min-width="110" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper v-numberAlign>{{ getSum(row.recharge_amount, row.recharge_bonus) }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_consume_count" label="实付金额(元)" min-width="110" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper v-numberAlign>{{ getSum(row.actually_paid) }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right"
                min-width="140">
                <template v-slot:header="{ row }">
                    <table-filter-payment :items="paymentTypes"
                        @confirm="filterPaymentConfirm"/>
                </template>
                <template v-slot="{ row }">
                    <p>{{ row.payment.custom_payment.name || row.payment.payment_type_text }}</p>
                </template>
            </el-table-column>
            <el-table-column min-width="10"/>
            <el-table-column label="操作"
                min-width="60">
                <template v-slot="{ row }">
                    <button class="text-btn pl-0"
                        @click="showRechargeDetail(row)">详情</button>
                </template>
            </el-table-column>
            <!-- <el-table-column label="收银员" min-width="160">
                <template v-slot="{ row }">
                    <user-info :userInfo="get(row, 'creator.user')"/>
                </template>
            </el-table-column> -->
            <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p>
            <p v-if="(!isHasMore) && rechargeRecord.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
        </el-table>
        <!-- component -->
        <add-member headerTitle='添加会员'
            :qrCodeUrl="qrCodeUrl"
            :visible.sync="isAddMemberVisible"
            :content="'顾客使用微信扫描下方小程序码，顾客注册后即可成为本店铺会员。'"/>
        <recharge-detail :visible.sync="isShowRechargeDetail"
            :rowData="curRowData"/>
        <MemberConfig 
            :visible.sync='isMemberConfigVisible'
            ref="memberConfig"
        />
    </div>
</template>

<script lang='ts'>
import MySearch from '@/components/search/search.vue'
import MoreOperate from '@/components/more_operate/more_operate.vue'
import AddMember from '../modules/add_member.vue'
import TableFilterPayment from '@/components/table_filter_payment/table_filter_payment.vue'
import RechargeDetail from '../recharge_detail/recharge_detail.vue'
import MemberConfig from '../member_config/member_config.vue'
import { createComponent, ref, onBeforeMount, onMounted } from '@vue/composition-api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import $fetch from '@/api'
import clone from 'lodash/cloneDeep'
import get from 'lodash/get'
import { setObjectItemToFixed, getSum } from '@/utils/index'
import paymentType from '@/config/payment_type'

export default createComponent({
    setup(props, ctx) {
        // reactive data
        const isMemberConfigVisible = ref(false)
        const qrCodeUrl = ref('')
        const oKeyword = ref('')
        const isAddMemberVisible = ref(false)
        const isLoading = ref(false)
        const isShowRechargeDetail = ref(false)
        const curRowData = ref<{ [prop: string]: any }>({})
        const paymentTypes = ref([])
        const rechargeRecord = ref([])
        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        // not reactive data
        let oStartDate = ''
        let oEndDate = ''
        let oPaymentList: number[] | undefined
        let oCustomPaymentIds: number[] | undefined

        // 组件的入口
        onBeforeMount(() => {
            console.log('paymentType', ctx.root.$store.getters)
            judgeParams()
            getQrCode()
            init()
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getRechargeRecord
            })
        })

        const init = () => {
            isLoading.value = true
            Promise.all([
                getRechargeRecord(),
                getPaymentType()
            ]).then(() => isLoading.value = false)
        }

        const judgeParams = () => {
            const params = ctx.root.$route.params
            console.log('params', params)
            if (params.start_date && params.end_date) {
                oStartDate = params.start_date
                oEndDate = params.end_date
            }
        }

        const getTime = (t: string) => {
            if (!t) { return {} }
            const arr = t.split(' ')
            return {
                y_m_d: arr[0],
                h_m_s: arr[1]
            }
        }

        // paymentType
        const getPaymentType = () => {
            return $fetch.post({
                url: '/shop/getconsumedpaymentconfig',
                params: {
                    start_date: oStartDate || undefined,
                    end_date: oEndDate || undefined,
                    // 0普通订单  1充值订单
                    order_type: 1
                }
            }).then(data => {
                console.log('支付方式信息', clone(data))
                paymentTypes.value = data
            }).catch(e => {
                openMessage('error', e.message || '获取支付方式失败')
            })
        }

        const getQrCode = () => {
            return $fetch.post({
                url: '/membership/getshopmembercardadmin'
            }).then(data => {
                console.log('二维码', data)
                qrCodeUrl.value = data.acode_url
            }).catch(e => openMessage('error', e.message || '获取二维码失败'))
        }

        const getRechargeRecord = (page: number = oPage.value, limit: number = 20, startDate: string = oStartDate, endDate: string = oEndDate, keyword: string = oKeyword.value, paymentList: number[] | undefined = oPaymentList, customPaymentIds: number[] | undefined = oCustomPaymentIds) => {
            let params
            if (startDate && endDate) {
                params = {
                    page,
                    limit,
                    payment_list: paymentList,
                    custom_payment_ids: customPaymentIds,
                    start_date: startDate,
                    end_date: endDate
                }
            } else {
                params = {
                    page,
                    limit,
                    payment_list: paymentList,
                    custom_payment_ids: customPaymentIds
                }
            }
            if (keyword !== '') {
                params.keyword = oKeyword.value
            }
            return $fetch.post({
                url: '/membership/memberrechargerecords',
                params
            }).then(data => {
                console.log('充值记录', clone(data))
                data = setObjectItemToFixed(data)
                if (page === 1) {
                    rechargeRecord.value = []
                    ctx.root.$nextTick(() => {
                        rechargeRecord.value = data.recharge_order_list
                        initScrollLoad(data)
                    })
                } else {
                    rechargeRecord.value = rechargeRecord.value.concat(data.recharge_order_list)
                }
                return data
            }).catch(e => openMessage('error', e.message || '获取充值记录失败'))
        }

        const searchData = (value: string, type: string) => {
            console.log(type, value)
            oKeyword.value = value
            oPage.value = 1
            isLoading.value = true
            getRechargeRecord()
                .finally(() => isLoading.value = false)
        }

        const filterPaymentConfirm = (val: {
            paymentList: number[] | undefined
            customPaymentIds: number[] | undefined
        }) => {
            oPaymentList = val.paymentList
            oCustomPaymentIds = val.customPaymentIds
            oPage.value = 1
            isLoading.value = true
            getRechargeRecord()
                .then(() => isLoading.value = false)
        }

        const showRechargeDetail = (row) => {
            curRowData.value = row
            isShowRechargeDetail.value = true
        }

        const hideMoreOperate = () => {
            (ctx.refs.moreoperate as any).hide()
        }

        const openMemberConfig = () => {
            (ctx.refs.memberConfig as any).open()
            hideMoreOperate()
        }

        return {
            // data
            isAddMemberVisible,
            isScrollLoading,
            isHasMore,
            isLoading,
            isShowRechargeDetail,
            paymentTypes,
            curRowData,
            qrCodeUrl,
            rechargeRecord,
            getTime,
            oKeyword,
            paymentType,
            // methods
            get,
            searchData,
            getSum,
            filterPaymentConfirm,
            showRechargeDetail,
            isMemberConfigVisible,
            openMemberConfig
        }
    },
    components: {
        AddMember,
        MySearch,
        TableFilterPayment,
        RechargeDetail,
        MemberConfig,
        MoreOperate
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-button {
    width: 100px;
    margin-right: 12px;
    padding-left: 0;
    padding-right: 0;
    text-align: center;
    box-sizing: border-box;
}

::v-deep .member_button {
    margin-right: 0;
    border-radius: 4px;
    border: 1px solid #009688;
    color: #009688;
}


.recharge-record {
    position: relative;
    
    .search-wrapper {
        position: absolute;
        right: 0;
        top: -54px;
        display: flex;
        align-items: center;
    }
}

.operate-detail-item {
    color: #333;

    > div {
        height: 36px;
        padding: 0 8px;
        line-height: 36px;
        cursor: pointer;

        &:hover {
            background: #F7F7F7;
        }
    }
}
</style>